<template>
  <modal :name="this.modalName" :draggable="false" :resizable="false" :height="150" :width="modalWidth || 620" @closed="modalClosed">
    <div class="modal_header">
      <p class="modal_title">{{ this.displayMessage || "" }}</p>
    </div>
    <div class="modal-body">
      <div class="modal_btn_div">
        <button class="btn btn-outline-primary modal_btn" v-on:click="this.handleClickPrimary">{{ this.primaryLabel || "OK" }}</button>
        <button class="btn btn-outline-primary" v-on:click="this.handleClickSecondary">{{ this.secondaryLabel || "Cancel" }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data: function () {
    return {
      "displayMessage": null,
      "onClickPrimary": null,
      "onClickSecondary": null,
      "asyncShowResolve": null,
    };
  },
  props: [
    "message",
    "primaryLabel",
    "secondaryLabel",
    "clickPrimary",
    "clickSecondary",
    "modalWidth"
  ],
  computed: {
    modalName: function () {
      return `modal_name_${this._uid}`;
    },
  },
  methods: {
    show(message = null, onClickPrimary = null, onClickSecondary = null) {
      this.displayMessage = message || this.message;
      this.onClickPrimary = onClickPrimary || this.clickPrimary;
      this.onClickSecondary = onClickSecondary || this.clickSecondary;
      this.asyncShowResolve = null;
      this.$modal.show(this.modalName);
    },
    async asyncShow(message = null) {
      this.show(message);
      return new Promise((resolve) => {
        this.asyncShowResolve = resolve;
      });
    },
    handleClickPrimary() {
      if (this.onClickPrimary) {
        this.onClickPrimary();
      }
      if (this.asyncShowResolve) {
        this.asyncShowResolve(true);
        this.asyncShowResolve = null;
      }
      this.$modal.hide(this.modalName);
    },
    handleClickSecondary() {
      this.$modal.hide(this.modalName);
      if (this.onClickSecondary) {
        this.onClickSecondary();
      }
    },
    modalClosed() {
      if (this.asyncShowResolve) {
        this.asyncShowResolve(false);
        this.asyncShowResolve = null;
      }
    }
  }
}
</script>

<style scoped>
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal_header {
  border-bottom: 1px solid #ddd;
  height: 60%;
  display: table;
  width: 100%;
}
.modal_title {
  color: black;
  /* line-height:100px; */
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.modal-body {
  margin: 0 auto;
}
.modal_btn_div {
  margin: 0 auto;
}
.modal_btn {
  margin: 0 10px 0 0;
}
</style>
